<template>
  <div
    style="cursor:default; display:flex;justify-content:start;height:100%;width:fit-content;z-index:1001;"
  >
    <transition name="slider_smallmenu">
      <div
        v-if="smallSidebarActive"
        :class="['sidebar', sidebarActive  ? 'active' : '']"
        @mouseout="$emit('mouseout')"
      >
        <!-- Profile  -->
        <!-- style="margin-top:40px;" -->
        <div
          :class="['layeroption', 'cursor-pointer',[sidebarActive ? 'active':'spacearound']]"
          @click="openExtendedSidebar('Profil')"
        >
          <SVGIcon
            name="user_wecker"
            v-if="ExtendedSidebarActiveLayer === 'Profil' && isSubscribed"
          />
          <SVGIcon
            name="user_saved"
            v-else-if="ExtendedSidebarActiveLayer === 'Profil' && (kartenansicht || routen.length !== 0)"
          />
          <SVGIcon
            name="user_on"
            v-else-if="ExtendedSidebarActiveLayer === 'Profil' && extendedSidebarActive"
          />
          <SVGIcon name="user_on" v-else/>
          <span v-if="sidebarActive" class="fontsize14">Mein Verkehrsservice</span>
        </div>

        <!-- Menü eingefahren => ausfahrbutton -->
        <div
          style="padding: 15.5px 0;height:46px;"
          :class="['toggleNav',sidebarActive ? 'hideNav':'']"
          @click="toggleSidebar"
        >
          <SVGIcon style="width:15px;height:15px;" name="slide_out" size="small" v-if="smallSidebarActive && !sidebarActive"/>
        </div>

        <!-- loop über die verfügbaren Layer in layers -->
        <div
          :class="['layeroption', 'cursor-pointer',[sidebarActive ? 'active':'spacearound']]"
          v-for="layer in layers"
          :key="layer.id"
          @click="layerChanged(layer.id, layer.active)"
        >
          <SVGIcon :name="getLayerName(layer)" v-if="layer.sidebarIcon.type === 'svg'"/>

          <img
            class="icon"
            :src="layer.active ? layer.sidebarIcon.img_on : layer.sidebarIcon.img_off"
            v-else
          >
          <span v-if="sidebarActive" class="fontsize14">{{ layer.name }}</span>
        </div>

        <!-- listenansicht  -->
        <div
          style="margin-top:12px;"
          :class="['layeroption', 'cursor-pointer',[sidebarActive ? 'active':'spacearound']]"
          @click="openExtendedSidebar('Listenansicht')"
        >
          <SVGIcon
            name="liste_on"
            v-if="ExtendedSidebarActiveLayer === 'Listenansicht' && extendedSidebarActive"
          />
          <SVGIcon name="liste_off" v-else/>
          <span v-if="sidebarActive" class="fontsize14">Listenansicht</span>
        </div>

        <!-- mobiles impressum / datenschutz -->
        <div v-if="sidebarActive">
          <div
            v-if="device === 'XS'"
            :class="['layeroption margintop20', 'cursor-pointer',[sidebarActive ? '':'spacearound']]"
            style="padding:0; color: #64b5f6;"
            @click="openExtendedSidebar('Partneransicht')"
          >
            <!-- <img src="@/assets/images/icons/partner.png" class="icon">  -->
            <span>Partnerportale</span>
          </div>
          <div
            v-if="device === 'XS'"
            :class="['layeroption', 'cursor-pointer',[sidebarActive ? '':'spacearound']]"
            style="padding: 0; color: #64b5f6;"
            @click="openExtendedSidebar('FAQ')"
          >
            <!-- <img src="@/assets/images/icons/partner.png" class="icon">  -->
            <span>FAQ</span>
          </div>
          <div
            v-if="device === 'XS'"
            :class="['layeroption', 'cursor-pointer',[sidebarActive ? '':'spacearound']]"
            style="padding: 0; color: #64b5f6;"
            @click="openExtendedSidebar('Impressum')"
          >
            <!-- <img src="@/assets/images/icons/partner.png" class="icon">  -->
            <span>Impressum</span>
          </div>
          <div
            v-if="device === 'XS'"
            :class="['layeroption', 'cursor-pointer',[sidebarActive ? '':'spacearound']]"
            style="padding: 0; color: #64b5f6;"
            @click="openExtendedSidebar('Datenschutz')"
          >
            <!-- <img src="@/assets/images/icons/partner.png" class="icon">  -->
            <span>Datenschutz</span>
          </div>

          <a
            v-if="device === 'XS'"
            :class="['layeroption', 'cursor-pointer',[sidebarActive ? '':'spacearound']]"
            target="_blank"
            rel="noopener noreferrer"
            href="https://mobil.hessen.de/irj/HSVV_Internet?cid=c1e0b8b5ce0108f5a47bab209691195b"
            style="padding: 0; color: #64b5f6;"
          >
            <span>Kontakt &raquo;</span>
          </a>
          <a
            v-if="device === 'XS'"
            :class="['layeroption cursor-pointer',[sidebarActive ? '':'spacearound']]"
            target="_blank"
            rel="noopener noreferrer"
            href="https://mobil.hessen.de/"
            style="padding: 0; padding-bottom:20px; color: #64b5f6;"
          >
            <span>Hessen Mobil &raquo;</span>
          </a>
        </div>
      </div>
    </transition>

    <transition name="slider_smallmenu_button">
      <!-- Kleines Menü ausgefahren => einklappbutton -->
      <div
        class="padding15 backgroundWhite borderRadiusRight05 cursor-pointer"
        style="position:absolute; z-index:1001; left: 60px;top:45px;"
        v-if="!sidebarActive && smallSidebarActive"
        @click="$store.commit('setSmallSidebar', false)"
      >
        <SVGIcon style="height:15px; width:15px;" name="slide_in" size="small"/>
      </div>
      <!-- </transition>
      <transition name="slider_smallmenu_button_out">-->
      <!-- Kleiens Menü eingefahren => ausfahrbutton -->
      <div
        class="padding15 backgroundWhite borderRadiusRight05 cursor-pointer"
        style="position:absolute; z-index:1001; left: 0;top:45px"
        v-if="!sidebarActive && !smallSidebarActive"
        @click="$store.commit('setSmallSidebar', true)"
      >
        <SVGIcon style="height:15px; width:15px;" name="slide_out" size="small"/>
      </div>
    </transition>
    <!-- Menü ausgefahren => einfahrbutton -->
    <div
      class="padding15 backgroundWhite borderRadiusRight05 cursor-pointer"
      :style="{transition:'left 0.5s',position:'absolute', zIndex:'1003',left: device === 'XS' ? '305.33px' :'320px', top:'45px'}"
      v-if="sidebarActive && smallSidebarActive"
      @click="toggleSidebar"
    >
      <SVGIcon style="height:15px; width:15px;" name="slide_in" size="small"/>
    </div>

    <ExtendedSidebar/>
  </div>
</template>

<script>
import ExtendedSidebar from './ExtendedSidebar/ExtendedSidebar.vue';

export default {
  name: 'Name',
  components: {
    ExtendedSidebar
  },
  computed: {
    smallSidebarActive() {
      return this.$store.state.smallSidebarActive;
    },
    isSubscribed() {
      return this.$store.state.isSubscribed;
    },
    sidebarActive() {
      return this.$store.state.sidebarActive;
    },
    layers() {
      return this.$store.state.layers.filter(layer => {
        return layer.sidebarIcon;
      });
    },
    allLayers() {
      return this.$store.state.layers;
    },
    extendedSidebarActive() {
      return this.$store.state.ExtendedSidebarActive;
    },
    ExtendedSidebarActiveLayer() {
      return this.$store.state.ExtendedSidebarActiveLayer;
    },
    device() {
      return this.$store.state.device;
    },
    kartenmode() {
      return this.$store.state.kartenmode;
    },
    kartenansicht() {
      return this.$store.state.kartenansicht;
    },
    routen() {
      return this.$store.state.routen;
    },
    isVerkehrsprognoseAktiv() {
      const layer = this.allLayers.find(layer => layer.id === 8);
      if (!layer) {
        return false;
      }
      return layer.active;
    }
  },
  methods: {
    toggleSidebar() {
      this.$store.commit('toggleSidebar');
      if (this.device !== 'XS') return;
      if (this.sidebarActive) {
        this.$root.$children[0].$refs.map.disableMapHandler();
      } else {
        this.$root.$children[0].$refs.map.enableMapHandler();
      }
    },
    openExtendedSidebar(optionName) {
      if (this.extendedSidebarActive) {
        if (this.ExtendedSidebarActiveLayer === optionName) {
          this.$store.commit('setExtendedSidebarActiveFalse');
        }
      } else {
        this.$store.commit('setExtendedSidebarActive');
      }
      this.$store.commit('setExtendedSidebar', optionName);
      if (this.kartenmode) this.$root.$children[0].$refs.map.stopKartenmode();
    },
    layerChanged(layerId, active) {
      // Wenn Staumeldungen geschlossen werden => schließen der Prognosemeldungen
      if (layerId === 0) {
        // alllayers[0] => Verkehrsmeldungen
        // alllayers[7] => Verkehrsprognosen
        if (this.allLayers[0].active || this.isVerkehrsprognoseAktiv) {
          // Wenn einer der beiden Layer aktiv ist und auf den Verkehrsmeldungsbutton gedrückt wird
          // => beide ausschalten
          this.$store.commit('setLayerActive', { layerId: 0, active: false });
          this.$store.commit('setLayerActive', { layerId: 8, active: false });
        } else {
          // Wenn keiner der beiden aktiv ist nur die aktuellen Verkehrsmeldungen und Dwistas aktivieren
          this.$store.commit('setLayerActive', { layerId: 0, active: true });
          this.$store.commit('setLayerActive', { layerId: 8, active: false });
        }
      } else {
        this.$store.commit('toggleLayerActive', layerId);
      }
      this.$emit('layerChanged');
    },
    getLayerName(layer) {
      if (layer.id === 0) {
        // Wenn Prognosen aktiviert sind => Staumeldungsicon aktiv halten
        return layer.active || this.isVerkehrsprognoseAktiv
          ? layer.sidebarIcon.img_on
          : layer.sidebarIcon.img_off;
      } else {
        return layer.active
          ? layer.sidebarIcon.img_on
          : layer.sidebarIcon.img_off;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sidebar {
  width: 60px;
  height: 100%;
  z-index: 1003;
  background-color: white;
  transition: all 0.5s ease-in-out;
  overflow-x: hidden;

  font-size: 16px;
  color: #4d4d4d;
  -webkit-transform: translate3d(0, 0, 0);
}

.sidebar.active {
  width: 100%;
  display: initial;
}
@media (min-width: 769px) {
  .sidebar.active {
    width: 320px;
  }
}
@media (max-width: 768px) {
  .sidebar.active {
    padding: 0px 30px;
  }
}

.phone-nav {
  background: #ffffff;
  position: fixed;
  left: 0;
  top: 70px;
  padding: 0;
  cursor: pointer;
  z-index: 1001;
}
.toggleNav {
  cursor: pointer;
  display: flex;
  justify-content: center;
}
.toggleNav.hideNav {
  justify-content: flex-end;
}

.layeroption {
  display: flex;
  flex-wrap: nowrap;
  max-height: 56px;
  padding: 4.5px 0;
}
.layeroption.active {
  padding-left: 20px;
}
.layeroption.spacearound {
  padding-left: 12px;
}
.layeroption span {
  margin-left: 15px;
  line-height: 34px;
}

/* SMALL MENU ANIMATION*/
.slider_smallmenu-enter,
.slider_smallmenu-leave-to {
  width: 0px;
}
.slider_smallmenu-leave,
.slider_smallmenu-enter-to {
  width: 60px;
}
.slider_smallmenu-enter-active,
.slider_smallmenu-leave-active {
  transition: width 0.5s;
}

/* SMALL MENU BUTTON IN ANIMATION*/
.slider_smallmenu_button-enter,
.slider_smallmenu_button-leave-to {
  left: 60px;
}
.slider_smallmenu_button-leave,
.slider_smallmenu_button-enter-to {
  left: 0;
}
.slider_smallmenu_button-enter-active,
.slider_smallmenu_button-leave-active {
  transition: left 0.5s;
}
</style>
